module.exports = __webpack_public_path__ + "static/media/German.76d25b1c.jpg";